import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { catFrecuenciaAct } from "../Categorias y Estados/catFrecuenciaAct";

const columns = () =>
(
    {
        c_servicio_id: new EntityColumn<string>({ name: 'c_servicio_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Servicio ID' }),
        c_codigoservicio_id: new EntityColumn<string>({ name: 'c_codigoservicio_id', type: 'char', length: 20, flags: c.FK, prompt: 'Código de servicio' }),
        vc_nombreservicio: new EntityColumn<string>({ name: 'vc_nombreservicio', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Nombre' }),
        bt_multiples_registros: new EntityColumn<boolean>({ name: 'bt_multiples_registros', type: 'bit', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Permitir Múltiples Registros' }),
        bt_encabezado: new EntityColumn<boolean>({ name: 'bt_encabezado', type: 'bit', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Encabezado' }),
        c_frecuenciaact_id: new EntityColumn<string>({ name: 'c_frecuenciaact_id', type: 'char', length: 20, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Frecuencia Retención' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        serv_brwStandard: { name: 'serv_brwStandard', keyMappings: { c_servicio_id: 0 } }
    }
)

const lookups = () =>
(
    {
        'FrecuenciaAct': {
            name: 'FrecuenciaAct',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catFrecuenciaAct(client, parentKeys)
        }
    }
)

export class ServiciosDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();

    constructor() {
        super('Servicios');
    }
}